import { signalBoot } from "./boot-signal";
import { main } from "./main";

// Prove the bundle executed before any other work (including the debug-swap
// below) — see boot-signal.ts. Fires here regardless of which path runs `main`.
signalBoot();

// Check for debug parameter in URL
function hasDebugParam(): boolean {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("debug") === "true";
  } catch {
    // Fallback for older browsers or edge cases
    return window.location.search.includes("debug=true");
  }
}

// If debug mode requested, dynamically load debug script
if (hasDebugParam()) {
  const win = window as typeof window & { __RAMP_DEBUG_LOADING__?: boolean };
  if (!win.__RAMP_DEBUG_LOADING__) {
    // Set flag to prevent multiple debug script loads
    win.__RAMP_DEBUG_LOADING__ = true;
    // Get the current script's URL and replace ramp.js with ramp.debug.js
    function getCurrentScriptUrl(): string {
      // Try to get current script URL
      const currentScript = document.currentScript as HTMLScriptElement;
      if (currentScript && currentScript.src) {
        return currentScript.src;
      }

      // Fallback: find script element whose pathname ends with ramp.js
      const scripts = document.querySelectorAll("script[src]");
      for (let i = 0; i < scripts.length; i++) {
        const script = scripts[i] as HTMLScriptElement;
        try {
          const url = new URL(script.src, window.location.href);
          if (url.pathname.endsWith("ramp.js")) {
            return script.src;
          }
        } catch {
          if (script.src && script.src.endsWith("ramp.js")) {
            return script.src;
          }
        }
      }

      // Last resort fallback - assume relative path
      return "./ramp.js";
    }

    const currentScriptUrl = getCurrentScriptUrl();
    console.log("🔍 Current script URL:", currentScriptUrl);

    // More robust replacement - handle various URL formats
    let debugScriptUrl;
    if (currentScriptUrl.includes("ramp.js")) {
      debugScriptUrl = currentScriptUrl.replace("ramp.js", "ramp.debug.js");
    } else {
      // Fallback - assume we can append debug version
      debugScriptUrl = currentScriptUrl.replace(/\.js(\?.*)?$/, ".debug.js$1");
    }

    console.log("🔍 Loading debug script from:", debugScriptUrl);

    // Double-check we're not loading the same script
    if (debugScriptUrl === currentScriptUrl) {
      console.warn("⚠️ Debug URL same as current URL, using fallback");
      debugScriptUrl = "./ramp.debug.js";
    }

    const debugScript = document.createElement("script");
    debugScript.src = debugScriptUrl;
    debugScript.async = true;

    debugScript.onload = () => {
      console.log("🐛 RampJS Debug mode activated");
      // Debug script will execute its own main() function
    };

    debugScript.onerror = (error) => {
      console.warn(
        "⚠️ RampJS Debug script failed to load, falling back to production mode",
        error,
      );
      // Fallback to production execution if debug script fails
      void main();
    };

    // Add debug script to page
    document.head.appendChild(debugScript);
  }
} else {
  // Normal production execution - immediate start
  void main();
}
